/**
 * skPropertyFiilters directive, used for filtering properties on the FBS multi-property mobile screens
 */
bookingApp.directive('skPropertyFilters', function(){
    return {
        scope: {
            filters: '=',
            getFilteredOnValues: '='
        },
        controller: function($scope){
            $scope.optionsLength = function(filter){
                if (filter && filter.options) {
                    return Object.keys(filter.options).length > 1;
                }
                return false;
            }
        },
        template: '<div class="property-filters">' +
            '<div class="filters">' +
                '<div class="property-filter" ng-repeat="filter in filters.filters | filter:optionsLength" ng-if="filters.displayed">' +
                    '<div class="sk-input-group col-xs-12 inactive" sk-select="static" ng-if="filter.enabled" ng-class="{\'multi-select\':filter.multi}">' +
                        '<label>{{filter.label}}</label>' +
                        '<select ng-if="filter.multi" ng-model="filter.selected" placeholder="abc" multiple>' +
                            '<option disabled></option>' +
                            '<option ng-repeat="option in filter.options | regionalFilter : getFilteredOnValues(filter.label)" value="{{option.id}}" ng-selected="isSelected(filter.selected, option)">{{option.val}}</option>' +
                        '</select>' +
                        '<select ng-if="!filter.multi" ng-model="filter.selected" placeholder="def" ng-options="key as value for (key, value) in filter.options"></select>' +
                    '</div>' +
                '</div>' +
                '<div class="property-filter-reset" ng-if="filters.displayed">' +
                    '<button class="btn btn-primary col-xs-12" ng-click="clearFilters()"><span class="glyphicon glyphicon-remove"></span> Clear Filters</button>' +
                '</div>' +
            '</div>' +
            '<div class="property-filters-shower">' +
                '<button class="btn btn-primary col-xs-12" ng-click="filters.displayed = !filters.displayed"><span ng-if="!filters.displayed">Show</span><span ng-if="filters.displayed">Hide</span> Filters <span class="glyphicon" ng-class="{\'glyphicon-chevron-up\':filters.displayed, \'glyphicon-chevron-down\':!filters.displayed}"></span></button>' +
            '</div>' +
        '</div>',
        link: function(scope, element, attrs){
            scope.isSelected = function(selected, option){
                if(selected && (selected.indexOf(option.id) > -1)){
                    return true;
                } else {
                    return false;
                }
            };
            scope.clearFilters = function(){
                angular.forEach(scope.filters.filters, function(filter){
                    filter.selected = null;
                });
            };
        }
    };
});
